interface ValidationOptions {
  limitSize?: number;
  extensions?: string[];
  [key: string]: any;
}

export default class ConvertFileBase64 {
  private input$: File | string;

  constructor(input: File | string) {
    this.input$ = input;
  }

  static convert(input: File | string) {
    return new ConvertFileBase64(input);
  }

  public validation(validations: ValidationOptions): ConvertFileBase64 {
    const selectedValidations = Object.keys(validations);
    const validationOptions: {
      [key: string]: {
        validationFunction: (value: any) => boolean;
        message: string;
      };
    } = {
      limitSize: {
        validationFunction: this.validateLimitSize,
        message: `O arquivo excedeu o limite de ${validations?.limitSize}`,
      },
      extensions: {
        validationFunction: this.validateExtension,
        message: `${
          validations?.extensions?.length !== 1
            ? "Os arquivos devem conter as extensões"
            : "O arquivo deve conter a extensão"
        } ${validations.extensions?.join(", ")}`,
      },
    };

    let error: string = "";

    selectedValidations.forEach((name) => {
      if (validationOptions[name]) {
        error = validationOptions[name].message;
      }
    });

    if (error) {
      throw new Error(error);
    }

    return this;
  }

  public async toBase64(): Promise<string> {
    const file = this.input$;

    return new Promise((resolve, reject) => {
      if (file instanceof File) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          const { result } = reader;
          const [mime, base64] = (result?.toString() || "").split(",");
          resolve(base64);
        };
        reader.onerror = (error) => {
          reject(error);
        };
      } else {
        reject(new Error("Arquivo inválido."));
      }
    });
  }

  //   public toFile(): File {
  //     return new File([], "");
  //   }

  private validateLimitSize(limitSize: number): boolean {
    if (this.input$ instanceof File) {
      return this.input$.size > limitSize;
    }
    return true;
  }

  private validateExtension(extensions: string[]) {
    if (this.input$ instanceof File) {
      const lastIndex = this.input$.name.lastIndexOf(".");
      const extension = this.input$.name.slice(lastIndex + 1);
      return extensions.includes(extension);
    }
    return true;
  }
}

export const imageUrlToBase64 = async (url: string): Promise<string> => {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error("Não foi possível carregar a imagem.");
  }
  const blob = await response.blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onload = () => {
      const result = reader.result?.toString() || "";
      const [, base64] = result.split(",");
      if (base64) {
        resolve(base64);
      } else {
        reject(new Error("Não foi possível converter a imagem para Base64."));
      }
    };
    reader.onerror = (error) => {
      reject(error);
    };
  });
};
